export default "__VITE_ASSET__C3TYE3d6__"